/* FlexFit Shopify theme - vanilla JS */
(function () {
  'use strict';

  var root = document.documentElement;
  var designMode = root.classList.contains('design-mode');
  var curtain = document.getElementById('pageCurtain');
  var routes = (window.FlexFit && window.FlexFit.routes) || { cartAdd: '/cart/add.js', cartJs: '/cart.js', cart: '/cart' };

  /* ---------- Curtain: intro reveal + page transition ---------- */
  var revealed = false;
  function curtainOut() {
    if (revealed) return;
    revealed = true;
    if (curtain) curtain.classList.add('out');
    setTimeout(function () { root.classList.add('is-ready'); }, curtain ? 350 : 0);
  }
  if (designMode) {
    root.classList.add('is-ready');
  } else if (document.readyState === 'complete') {
    setTimeout(curtainOut, 300);
  } else {
    window.addEventListener('load', function () { setTimeout(curtainOut, 500); });
  }
  setTimeout(curtainOut, 4000);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { revealed = false; curtainOut(); }
  });

  document.addEventListener('click', function (e) {
    if (!curtain || !root.classList.contains('has-transition') || designMode) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || a.target === '_blank' || a.hasAttribute('download') || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/.test(href)) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    if (/\/(cart\/add|checkout)/.test(url.pathname)) return;
    e.preventDefault();
    curtain.classList.remove('out');
    curtain.classList.add('reset');
    void curtain.offsetWidth;
    curtain.classList.remove('reset');
    setTimeout(function () { location.href = a.href; }, 600);
  });

  /* ---------- Header ---------- */
  function onScroll() {
    var header = document.getElementById('siteHeader');
    if (header) header.classList.toggle('scrolled', window.scrollY > 40);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('DOMContentLoaded', onScroll);

  document.addEventListener('click', function (e) {
    var burger = e.target.closest('#burgerBtn');
    var nav = document.getElementById('mainNav');
    if (!nav) return;
    if (burger) {
      var open = nav.classList.toggle('open');
      burger.classList.toggle('active', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    } else if (e.target.closest('#mainNav a')) {
      nav.classList.remove('open');
      var b = document.getElementById('burgerBtn');
      if (b) { b.classList.remove('active'); b.setAttribute('aria-expanded', 'false'); }
    }
  });

  /* ---------- Scroll reveal ---------- */
  var io;
  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.in)');
    if (designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Hero slider ---------- */
  function initSliders(scope) {
    (scope || document).querySelectorAll('[data-hero-slider]').forEach(function (el) {
      if (el._sliderInit) return;
      el._sliderInit = true;
      var slides = el.querySelectorAll('.slide');
      var dots = el.querySelectorAll('.dot');
      var speed = (parseInt(el.getAttribute('data-speed'), 10) || 6) * 1000;
      var auto = el.getAttribute('data-autoplay') !== 'false';
      var cur = 0, timer;

      function show(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('active', k === cur); });
        dots.forEach(function (d, k) { d.classList.toggle('active', k === cur); });
      }
      function stop() { clearInterval(timer); }
      function start() {
        stop();
        if (auto && slides.length > 1 && !designMode) timer = setInterval(function () { show(cur + 1); }, speed);
      }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
      el._showSlide = show;
      start();
    });
  }

  /* ---------- Collection tabs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tab-btn]');
    if (!btn) return;
    var wrap = btn.closest('[data-tabs]');
    if (!wrap) return;
    var id = btn.getAttribute('data-tab-btn');
    wrap.querySelectorAll('[data-tab-btn]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    wrap.querySelectorAll('[data-tab-panel]').forEach(function (p) {
      p.classList.toggle('active', p.getAttribute('data-tab-panel') === id);
    });
  });

  /* ---------- Toast + cart count ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.toggle('error', !!isError);
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }
  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- Ajax add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-ajax-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.d.description || res.d.message || 'Could not add this item', true);
          return null;
        }
        return fetch(routes.cartJs).then(function (r) { return r.json(); }).then(function (c) {
          updateCount(c.item_count);
          toast('✅ Item added to cart!');
        });
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- Wishlist (saved in this browser) ---------- */
  var WL_KEY = 'flexfit-wishlist';
  function getWl() { try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; } }
  function setWl(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} }
  function paintWishlist(scope) {
    var list = getWl();
    (scope || document).querySelectorAll('[data-wishlist]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wishlist')) > -1;
      b.classList.toggle('on', on);
      b.innerHTML = on ? '&#9829;' : '&#9825;';
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wishlist');
    var list = getWl();
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    setWl(list);
    paintWishlist();
  });

  /* ---------- Product page ---------- */
  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-product]').forEach(function (wrap) {
      if (wrap._productInit) return;
      wrap._productInit = true;
      var dataEl = wrap.querySelector('[data-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = wrap.querySelector('input[name=id]');
      var price = wrap.querySelector('[data-price]');
      var compare = wrap.querySelector('[data-compare]');
      var btn = wrap.querySelector('[data-add-btn]');
      var mainImg = wrap.querySelector('[data-main-image]');

      function selected() {
        var vals = [];
        wrap.querySelectorAll('[data-option]').forEach(function (g) {
          var c = g.querySelector('input:checked');
          vals.push(c ? c.value : null);
        });
        return vals;
      }
      function update() {
        var vals = selected();
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === vals[i]; });
        })[0];
        if (!btn) return;
        if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        if (price) price.textContent = v.price;
        if (compare) { compare.textContent = v.onSale ? v.compare : ''; compare.hidden = !v.onSale; }
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-label') : 'Sold out';
        if (v.image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = v.image; }
        try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) {}
      }
      wrap.addEventListener('change', function (e) {
        if (e.target.closest('[data-option]')) update();
      });
      wrap.addEventListener('click', function (e) {
        var t = e.target.closest('[data-thumb]');
        if (t && mainImg) {
          mainImg.removeAttribute('srcset');
          mainImg.src = t.getAttribute('data-thumb');
          wrap.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('active', x === t); });
        }
        var q = e.target.closest('[data-qty]');
        if (q) {
          var input = wrap.querySelector('[name=quantity]');
          var val = parseInt(input.value, 10) || 1;
          val += q.getAttribute('data-qty') === 'plus' ? 1 : -1;
          input.value = Math.max(1, val);
        }
      });
    });
  }

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort]');
    if (!s) return;
    var u = new URL(location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });

  /* ---------- Cart page qty buttons ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (!q) return;
    var input = q.parentNode.querySelector('input');
    var val = parseInt(input.value, 10) || 0;
    val += q.getAttribute('data-cart-qty') === 'plus' ? 1 : -1;
    input.value = Math.max(0, val);
  });

  /* ---------- Init + theme editor support ---------- */
  function initAll(scope) {
    initReveal();
    initSliders(scope);
    initProduct(scope);
    paintWishlist(scope);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slider = e.target.closest('[data-hero-slider]');
    if (slider && slider._showSlide && e.target.classList.contains('slide')) {
      slider._showSlide(Array.prototype.indexOf.call(slider.querySelectorAll('.slide'), e.target));
    }
    if (e.target.hasAttribute && e.target.hasAttribute('data-tab-panel')) {
      var b = document.querySelector('[data-tab-btn="' + e.target.getAttribute('data-tab-panel') + '"]');
      if (b) b.click();
    }
  });
})();
